import React from "react"
import styled from "styled-components"
import Cc from "../assets/cc.svg"
import By from "../assets/by.svg"
import Sa from "../assets/sa.svg"

const LicenseWrapper = styled.div`
  svg {
    height: 16px;
    width: 16px;
    margin-bottom: 0px;
    margin-left: 3px;
    vertical-align: text-bottom;
    & path {
      stroke: ${(props) => props.theme.colors.text};
      fill: ${(props) => props.theme.colors.text};
    }
  }
`

const License = ({ year }) => {
  return (
    <LicenseWrapper>
      <div>
        &copy; {year}{" "}
        <a rel="cc:attributionURL" href="https://kepi.cz/kepi">
          <span rel="cc:attributionName">Ondra Kudlík (Kepi)</span>
        </a>
        &nbsp;
        <span
          {...{
            "xmlns:dct": "http://purl.org/dc/terms/",
            "xmlns:cc": "http://creativecommons.org/ns#",
          }}
        >
          <a rel="cc:attributionURL" href="https://kepi.cz">
            <span rel="dct:title"> All cultural works</span>
          </a>{" "}
          by{" "}
          <a href="https://creativecommons.org/licenses/by-sa/4.0">
            CC BY-SA 4.0 <Cc />
            <By />
            <Sa />
          </a>
        </span>
      </div>
      <div>
        <span>
          All code shared on this blog, unless otherwise noted, is hereby released under the{" "}
          <a href="https://opensource.org/licenses/MIT">MIT License</a>.
        </span>
      </div>
    </LicenseWrapper>
  )
}
export default License
